import { BestReview } from '../types/pages/tour';
import { ConvertPublicUrlToGsUrl } from './ConvertPublicUrlToGsUrl';
import { useAuthContext } from './context/authContext';

export const useTransformReview = () => {
  const { user }: any = useAuthContext();

  const transformReview = async (review: any, reviews: any[]): Promise<any> => {
    const createdAtISO = review?.created_at;
    let dateAndTime = 'N/A';

    if (createdAtISO) {
      if (typeof createdAtISO === 'string') {
        // ISO format
        dateAndTime = new Date(createdAtISO).toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      } else if (createdAtISO?._seconds) {
        // Firebase Timestamp format
        const dateFromSeconds = new Date(createdAtISO._seconds * 1000);
        dateAndTime = dateFromSeconds.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      }
    }

    const fullName =
      review?.traveller?.split(' ') || review?.name?.split(' ') || [];
    const firstName = fullName[0] || 'Anonymous';
    const lastName = fullName[1] || '';
    const displayName =
      lastName.toLowerCase() !== 'undefined'
        ? `${firstName} ${lastName}`
        : firstName;

    let userGsUrl = '';

    if (user?.photoURL) {
      if (user?.uid === review?.user_id) {
        localStorage.setItem('user_gs_url', review.gs_url);
      } else {
        const userHasReviewed = reviews.some(
          (r: any) => user?.uid === r?.user_id
        );
        if (!userHasReviewed && user?.photoURL) {
          userGsUrl = await ConvertPublicUrlToGsUrl(user.photoURL);
          localStorage.setItem('user_gs_url', userGsUrl);
        }
      }
    }

    return {
      rating: review?.rating,
      time: dateAndTime,
      name:
        review?.review?.user_id && review?.review?.user_id === user?.uid
          ? user?.displayName
          : displayName || 'Anonymous',
      review: review?.review || 'No review provided.',
      image:
        review?.user_id === user?.uid ? user?.photoURL : review?.user_image,
      reviewId: review?.id,
      userId: review?.user_id,
      gs_url: review.gs_url || userGsUrl
    };
  };

  return { transformReview };
};

export const transformBestReview = (review: any): BestReview => ({
  id: review.id || '',
  title: review.title || '',
  review: review.review || 'No review provided.',
  traveller: review.traveller || review.name || 'Anonymous',
  rating: review.rating || 0,
  source: review.source || '',
  date: new Date(review.created_at).toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }),
  created_at: review.created_at || ''
});
